export default "__VITE_ASSET__BPg4EKvg__"